<template>
  <div class="proceed-btn-wrap">
    <button class="proceed-btn" @click="$emit('click')">
      <span class="btn-text">Proceed</span>
      <span class="btn-bg-shape"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AnimatedProceedButton',
};
</script>

<style scoped>
.proceed-btn-wrap {
  text-align: center;
}

.proceed-btn {
  background: linear-gradient(135deg, #f46523, #ff9800);
  color: white;
  padding: 16px 90px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  box-shadow:
    0 4px 15px rgba(244, 101, 35, 0.3),
    0 8px 30px rgba(244, 101, 35, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition:
    transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    box-shadow 0.4s ease,
    background 0.3s ease;
  position: relative;
  overflow: hidden;
}

.proceed-btn:hover {
  transform: translateY(-6px) scale(1.05) translateZ(0);
  background: linear-gradient(135deg, #e5581f, #f49800);
  box-shadow:
    0 8px 25px rgba(244, 101, 35, 0.4),
    0 16px 50px rgba(244, 101, 35, 0.25),
    0 32px 100px rgba(244, 101, 35, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.proceed-btn:active {
  transform: translateY(-2px) scale(1.02);
  box-shadow:
    0 4px 15px rgba(244, 101, 35, 0.5),
    0 8px 30px rgba(244, 101, 35, 0.3);
}
</style>
